import { getListOfRcsBotConfigs , addRcsBotConfig , updateRcsBotConfig , deleteRcsBotConfig} from "../types/account_rcs_bots_types";

const initState = {
    data: [],
    loading: false,
    error: null,
};

export default function accountRcsBotConfigReducer(state = initState, action = {}) {
    switch (action.type) {
        case getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null,
            };
        case getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

            // Add new bot config
            case addRcsBotConfig.ADD_RCS_BOT_CONFIG_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case addRcsBotConfig.ADD_RCS_BOT_CONFIG_SUCCESS:
                const { botName , brandLogo , botId , botSecret , vendor , supportedCountry} = action.payload.data.settings;
                const newPayload = {
                    _id : action.payload.data._id ,
                    botName,
                    brandLogo,
                    botId,
                    botSecret,
                    vendor,
                    supportedCountry
                }
                return {
                    ...state,
                    loading: false,
                    data: [...state.data, newPayload],
                    error: null,
                };

            case addRcsBotConfig.ADD_RCS_BOT_CONFIG_ERROR:
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                };

             // Update    
            case updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_SUCCESS:
                const _id = action.payload.data.settingId;
                const updatedBotConfig = {
                    _id: action.payload.data.settingId,
                    botName: action.payload.data.botName,
                    brandLogo: action.payload.data.brandLogo
                };
                const updatedData = state.data.map(item =>
                    item._id === _id ? { ...item, ...updatedBotConfig } : item
                );
                return {
                    ...state,
                    loading: false,
                    data: updatedData,
                    error: null,
                };

            case updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_ERROR:
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                };

            // Delete new bot config
            case deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    data:  state.data.filter(item => item._id !== action.payload.settingId),
                    error: null,
                };

            case deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_ERROR:
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                };
        default:
            return state;
    }
}
